import { render, staticRenderFns } from "./single-product-autocomplete.vue?vue&type=template&id=237ac6cc&scoped=true&"
import script from "./single-product-autocomplete.vue?vue&type=script&lang=js&"
export * from "./single-product-autocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237ac6cc",
  null
  
)

export default component.exports